/**
* 基础菜单 会员服务管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>会员服务管理</el-breadcrumb-item>
        <el-breadcrumb-item>商品评价管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <div class="block">
          <el-date-picker
            v-model="order_complete_time"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_name" placeholder="商品名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_code" placeholder="商品编码" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.cust_name" placeholder="评价人" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.discuss_type" placeholder="评价类型" clearable>
          <el-option label="好评" value="270"></el-option>
          <el-option label="中评" value="271"></el-option>
          <el-option label="差评" value="272"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.star_degree" placeholder="满意度" clearable>
          <el-option label="1" value="1"></el-option>
          <el-option label="2" value="2"></el-option>
          <el-option label="3" value="3"></el-option>
          <el-option label="4" value="4"></el-option>
          <el-option label="5" value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
         <el-select v-model="formInline.approval_status" placeholder="请选择审核状态" clearable>
           <el-option v-for="approvalStatus in approvalStatusList" :key="approvalStatus.value" :label="approvalStatus.name"
                      :value="approvalStatus.value"></el-option>
         </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="success" @click="examine" class="add-button">审核</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          fixed
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="product_name" fixed label="商品名称" width="200" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="product_code" fixed label="商品编码" min-width="120" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="order_complete_time" fixed label="订单完成时间" width="150" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="star_degree" fixed label="满意度" width="96" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="discuss_type" fixed label="评价类型" width="96" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div v-if="scope.row.discuss_type==270">好评</div>
            <div v-else-if="scope.row.discuss_type==271">中评</div>
            <div v-else>差评</div>
            <div></div>
          </template>
        </el-table-column>
        <el-table-column prop="cust_name" fixed label="评价人" width="100" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="discuss_content" fixed label="评价内容" width="200" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="discuss_time" fixed label="评价时间" width="160" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="answer_content" label="回复内容" width="200" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="answer_user_name" label="回复人" width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="answer_time" label="回复时间" width="200" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="approval_status" label="审核状态" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.approval_status==262">审核不通过</div>
            <div v-else-if="scope.row.approval_status==261">审核通过</div>
            <div v-else="scope.row.approval_status==260">未审核</div>
          </template>
        </el-table-column>
        <el-table-column prop="approval_remark" label="审核意见" width="200" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="approval_time" label="审核时间" width="200" :show-overflow-tooltip='true'>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 审核弹窗 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="审核评价"
               :visible.sync="discussDialogVisible"
               width="30%"
               :before-close="handleBrandClose"
               center>
      <el-form :model="questionForm" :rules="rules" ref="questionForm" label-width="125px" class="brandForm">
        <el-form-item label="审核状态" prop="approval_status">
          <el-select v-model="questionForm.approval_status" placeholder="请选择审核状态" clearable>
            <el-option v-for="approvalStatus in approvalStatusList" :key="approvalStatus.value" :label="approvalStatus.name"
                       :value="approvalStatus.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核意见" prop="approval_remark" class="discuss">
          <el-input
            type="textarea"
            placeholder="请输入审核意见"
            v-model="questionForm.approval_remark"
            maxlength="200"
            :autosize="{ minRows: 4, maxRows: 10}"
            show-word-limit
            resize="none"
            auto-complete="off"
            clearable
          >
          </el-input>
        </el-form-item>
<!--        <el-form-item label="评价内容" prop="discuss_content" class="discuss"> -->
<!--          <el-input -->
<!--            type="textarea" -->
<!--            v-model="questionForm.discuss_content" -->
<!--            maxlength="200" -->
<!--            :autosize="{ minRows: 4, maxRows: 10}" -->
<!--            :disabled="true" -->
<!--            resize="none" -->
<!--          > -->
<!--          </el-input> -->
<!--        </el-form-item> -->
        <div class="flex_box billing_item mb22">
          <p class="label f14 color666">评价内容</p>
          <span class="f14 color333">{{discussData.discuss_content}}</span>
        </div>
        <el-form-item label="回复内容" prop="answer_content" class="discuss">
          <el-input
            type="textarea"
            placeholder="请输入回复内容"
            v-model="questionForm.answer_content"
            maxlength="200"
            :autosize="{ minRows: 4, maxRows: 10}"
            show-word-limit
            resize="none"
            auto-complete="off"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="handleBrandClose">取消</el-button>
            <el-button type="primary" @click="questionFirm('questionForm')">确认</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import {
    discussList,discussApprove,discussDetail
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {param} from '../../api/commonMG'
  import {timestampToDate} from "../../utils/util";

  export default {
    data: () => {
      return {
        loading: false, // 显示加载
        discussDialogVisible: false, // 控制页面显示与隐藏
        productId: '',
        selectTableData: [],
        formInline: {
          page: 1,
          rows: 10,
          product_code: '',
          product_name: '',
          start_discuss_time: '',
          end_discuss_time: '',
          cust_name: '',
          discuss_content: '',
          discuss_type: '',
          star_degree: '',
          approval_status: ''
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        questionForm: {
          id: '',
          answer_content: '',
          approval_status: '',
          approval_remark: ''
        },
        addDetailData: {},
        discussData: {},
        // rules表单验证
        rules: {
          approval_status: [{required: true, message: '请选择审核状态', trigger: 'blur'}],
          approval_remark: [{required: true, message: '请输入审核意见', trigger: 'blur'}],
          answer_content: [{required: true, message: '请输入回复内容', trigger: 'blur'}],
        },
        order_complete_time: '',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        approvalStatusList: [
          {
            name: '未审核',
            value: 260
          }, {
            name: '审核通过',
            value: 261
          }, {
            name: '审核不通过',
            value: 262
          }
        ],
        cust_name: "",
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    mounted() {
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        discussList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      // 审核
      examine() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        if (this.selectTableData[0].approval_status != '261' && this.selectTableData[0].approval_status != '262') {

        } else {
          this.$message.error('请选择未审核的商品评价!');
          return
        }
        this.discussDialogVisible = true;
        this.productId = this.selectTableData[0].id;
        this.questionForm.answer_content = this.selectTableData[0].answer_content;
        this.questionForm.approval_status = this.selectTableData[0].approval_status;
        this.questionForm.approval_remark = this.selectTableData[0].approval_remark;
        this.examineDetail(this.selectTableData[0].id);
      },
      examineDetail(id) {
        discussDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.discussData = res.content || '';
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      questionFirm(formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            this.questionForm.id = this.productId;
            this.loading = true;
            discussApprove(this.questionForm)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '您已成功审核评价!'
                  })
                  this.discussDialogVisible = false;
                  this.getdata(this.formInline)
                }
              })
              .catch(err => {
                this.loading = false;
                this.$message.error('网络错误,请稍后再试!')
              })
          } else {
            console.log('error submit!!');
          }
        })
        // this.questionForm.id = this.productId;
        // this.loading = true;
        // discussApprove(this.questionForm)
        //   .then(res => {
        //     this.loading = false
        //     if (res.success == false) {
        //       this.$message({
        //         type: 'info',
        //         message: res.msg
        //       })
        //     } else {
        //       this.$message({
        //         type: 'success',
        //         message: '您已成功审核评价!'
        //       })
        //       this.discussDialogVisible = false;
        //       this.getdata(this.formInline)
        //     }
        //   })
        //   .catch(err => {
        //     this.loading = false
        //     this.$message.error('网络错误，请稍后再试！')
        //   })
      },
      handleBrandClose() {
        this.discussDialogVisible = false;
      },
      // 搜索事件
      search() {
        if (this.order_complete_time) {
          this.formInline.start_discuss_time = timestampToDate(this.order_complete_time[0])
          this.formInline.end_discuss_time = timestampToDate(this.order_complete_time[1])
        } else {
          this.formInline.start_discuss_time = ''
          this.formInline.end_discuss_time = ''
        }
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.product_name == cell.innerText || row.product_code == cell.innerText || row.cust_name == cell.innerText || row.question_content == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .voucherForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .voucherForm .el-input {
    width: 320px;
  }

  /deep/ .voucherForm .el-input--small {
    width: 320px;
  }

  /deep/ .sortForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .sortForm .el-input {
    width: 320px;
  }

  /deep/ .sortForm .el-input--small {
    width: 320px;
  }

  /deep/ .brandForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .brandForm .el-input {
    width: 320px;
  }

  /deep/ .brandForm .el-input--small {
    width: 320px;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  /deep/ .discuss .el-textarea {
    width: 320px;
  }

  /deep/ .el-select-dropdown__item .selected {
      color: #333;
      font-weight: 400;
  }

  .mb22 {
    margin-bottom: 22px;
  }

  .f14 {
    font-size: 14px;
  }

  .flex_box {
    display: flex;
  }

  .billing_item span {
    width: 320px;
    line-height: 22px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }

  .label {
    width: 125px;
    height: 32px;
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #333333;
    line-height: 22px;
    padding: 5px 12px 5px 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .label:before {
      content: '*';
      color: #F56C6C;
      margin-right: 4px;
  }

</style>





// WEBPACK FOOTER //
// src/views/service/Reviews.vue